// extracted by mini-css-extract-plugin
export default {"gridContainer":"PayersList_gridContainer__yyeiF"};